import api from './api';

const ciudadService = {
  // Obtener todas las ciudades
  getCiudades: async () => {
    try {
      const response = await api.get('/api/cities');
      return response.data;
    } catch (error) {
      console.error('Error al obtener ciudades:', error);
      throw error;
    }
  },

  // Obtener una ciudad por ID
  getCiudadById: async (id) => {
    try {
      const response = await api.get(`/api/cities/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener ciudad con ID ${id}:`, error);
      throw error;
    }
  },

  // Crear una nueva ciudad
  createCiudad: async (name) => {
    try {
      // Construir el objeto con los valores por defecto requeridos
      const ciudadData = {
        name: name,
        state: "Antioquia",
        country: "Colombia",
        isActive: true,
        iconUrl: ""
      };

      
      
      const response = await api.post('/api/cities', ciudadData);
      return response.data;
    } catch (error) {
      console.error('Error al crear ciudad:', error);
     
      throw error;
    }
  },

  // Actualizar una ciudad existente
  updateCiudad: async (id, ciudadData) => {
    try {
      const response = await api.put(`/api/cities/${id}`, ciudadData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar ciudad con ID ${id}:`, error);
      throw error;
    }
  },

  // Eliminar una ciudad
  deleteCiudad: async (id) => {
    try {
      const response = await api.delete(`/api/cities/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar ciudad con ID ${id}:`, error);
      throw error;
    }
  }
};

export default ciudadService;
